import { SelectProps, StatusIndicatorProps } from "@amzn/awsui-components-react";
import { getString } from "common/ui-string-labels/ui-strings-utils";
import { VENDORS, BulkOrderStatus, formatStatusLabel } from "configuration/config";

export const STATUS_MAP: Record<string, { type: StatusIndicatorProps.Type; label: string }> = {
    [BulkOrderStatus.NEW]: { type: "info", label: formatStatusLabel(BulkOrderStatus.NEW) },
    [BulkOrderStatus.PENDING_RESELLER]: { type: "in-progress", label: formatStatusLabel(BulkOrderStatus.PENDING_RESELLER) },
    [BulkOrderStatus.COMPLETED]: { type: "success", label: formatStatusLabel(BulkOrderStatus.COMPLETED) },
    [BulkOrderStatus.CANCELLED]: { type: "error", label: formatStatusLabel(BulkOrderStatus.CANCELLED) },
};

export const VENDOR_FILTER_OPTIONS: SelectProps.Option[] = [
    { label: getString("manageOrders.filters.vendorPlaceholder"), value: "" },
    ...VENDORS.map((v) => ({ label: v.label, value: v.id })),
];

export const STATUS_FILTER_OPTIONS: SelectProps.Option[] = [
    { label: getString("manageOrders.filters.statusPlaceholder"), value: "" },
    ...Object.entries(STATUS_MAP).map(([value, { label }]) => ({ label, value })),
];
